import React from "react";
import { getWaybillValidator } from "../../ShipButton/getWaybillValidator";
import { preShipShopTypes } from "@/utils/ShopUtils";
import OrderManagementStore from "@/scenes/OrderManagement/store/OrderManagementStore";
import { ModalStore } from "@/hooks/Modal/ModalStore";
import PreShipValidateErrorModal from "../PreShipValidateErrorModal";
import OrderDTO from "@/dto/order/OrderDTO";

export function getPreShipWaybillValidator(
    allOrders: OrderDTO[],
    modalStore: ModalStore,
    orderManagementStore: OrderManagementStore,
) {
    return getWaybillValidator({
        allOrders,
        isPreShipShopType: (shopType) => preShipShopTypes.includes(shopType),
        onWaybillError: (errorDataSource, validOrders) => {
            errorDataSource.forEach((it) => {
                orderManagementStore.table.updateOrder(it.orderId, {
                    waybillNoInputValidateErrorMsg: it.errorMessage,
                    waybillNoInputValidationActived: true,
                });
            });

            return new Promise((resolve, rejected) => {
                modalStore.openModal(PreShipValidateErrorModal, {
                    dataSource: errorDataSource,
                    canShipOrders: validOrders,
                    onContinue() {
                        resolve(true);
                    },
                    onAbort() {
                        rejected(false);
                    },
                });
            });
        },
    });
}
